import { type ReactNode } from "react";
import { Stack } from "@volca/ui/components/ui/stack";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@volca/ui/components/ui/table";
import { cn } from "@volca/ui/lib/utils";

export const ExampleTable = ({
  headers,
  rows,
  caption,
  selectionColumn = false,
}: {
  headers: ReactNode[];
  rows: ReactNode[][];
  caption: string;
  selectionColumn?: boolean;
}) => (
  <Stack gap={0} align="stretch" className="min-w-0 overflow-x-auto">
    <Table className="text-sm">
      <caption className="sr-only">{caption}</caption>
      <TableHeader className="static">
        <TableRow>
          {headers.map((heading, index) => (
            <TableHead
              key={index}
              className={cn("h-10 whitespace-nowrap", {
                "w-14 px-0 [&:has([role=checkbox])]:pr-0":
                  selectionColumn && index === 0,
              })}
            >
              {selectionColumn && index === 0 ? (
                <Stack align="center" justify="center" gap={0} className="w-14">
                  {heading}
                </Stack>
              ) : (
                heading
              )}
            </TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.map((row, index) => (
          <TableRow key={index}>
            {row.map((cell, col) => (
              <TableCell
                key={col}
                className={cn("py-3 whitespace-nowrap", {
                  "w-14 px-0": selectionColumn && col === 0,
                })}
              >
                {selectionColumn && col === 0 ? (
                  <Stack
                    align="center"
                    justify="center"
                    gap={0}
                    className="w-14"
                  >
                    {cell}
                  </Stack>
                ) : (
                  cell
                )}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Stack>
);
